import React, { CSSProperties, ReactNode } from 'react';

interface Props {
  title: ReactNode;
  style?: CSSProperties; // optional, type-safe
}

const CardTitle: React.FC<Props> = ({ title, style }) => {
  return (
    <h2
      style={{
        fontWeight: 700,
        margin: 0,
        fontSize: '20px',
        ...style,
      }}
    >
      {title}
    </h2>
  );
};

export default CardTitle;
